module.exports = __webpack_public_path__ + "img/comment.0f0185a4.svg";